import { allowedRedirectDomains } from '@lib/constants';
import { getConfig } from '@chegg-web-tools/config-plugin';

export { setRedirectUrl };

function setRedirectUrl(newRedirect: string | undefined) {
  if (!newRedirect) return '';
  return validateRedirectUrl(newRedirect);
}

export function validateRedirectUrl(uri: string) {
  const envUrl = getConfig('envBaseUrl');

  if (uri.startsWith('/')) {
    return window.location.origin + uri;
  }
  if (uri && uri.startsWith('http')) {
    const url = new URL(uri);
    const allowedDomain = allowedRedirectDomains.find(
      (item) => url.origin.substr(-1 * item.length) == item
    );
    if (allowedDomain) {
      return url;
    }
  } else {
    return envUrl;
  }
}
